/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/whats_app/message_templates/save_as_draft" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdWhatsAppMessageTemplatesCacheKeys } from "./constants";
import type {
  PostEngagementAppGroupIdWhatsAppMessageTemplatesSaveAsDraftProps,
  PostSaveWhatsAppMessageTemplateAsDraftResponse,
} from "./types";

export const postSaveWhatsAppMessageTemplateAsDraft = reactQueryMutationAdapter(
  engagementAppGroupIdWhatsAppMessageTemplatesCacheKeys,
  ({
    appGroupId,
    requestBody,
  }: PostEngagementAppGroupIdWhatsAppMessageTemplatesSaveAsDraftProps): Promise<PostSaveWhatsAppMessageTemplateAsDraftResponse> => {
    return fetch(
      `/engagement/${appGroupId}/whats_app/message_templates/save_as_draft`,
      "POST",
      requestBody,
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
